import { render, staticRenderFns } from "./nat.vue?vue&type=template&id=1f55c864"
import script from "./nat.vue?vue&type=script&lang=js"
export * from "./nat.vue?vue&type=script&lang=js"
import style0 from "./nat.vue?vue&type=style&index=0&id=1f55c864&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports